import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"

export default function Products({gridMode}) {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    console.log("products", products);

    return (
        <div class={`productgrid--items ${gridMode ? 'productgrid-gridview' : 'productgrid-listview'}`} id="nosto-serp-template" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
